import { useTranslation } from "react-i18next";
import { Box, Typography, makeStyles } from "@material-ui/core";
import ButtonWithLoading from "components/ButtonWithLoading";
import type { MalwareContent, MalwareFile } from "@dashboard-v3/api";
import FileRow from "./FileRow";

interface Props {
  content: MalwareContent;
  files: MalwareFile[];
  loading: boolean;
  onShowAll: (content: MalwareContent) => void;
  onFileClick: (file: MalwareFile, content: MalwareContent) => void;
}

export default function ContentFiles({
  content,
  files,
  loading,
  onShowAll,
  onFileClick,
}: Props) {
  const { t } = useTranslation("mxheroShares");
  const classes = useStyles();
  const hasMoreFiles = content.filesCount > files.length;

  if (files.length === 0) {
    return (
      <Typography
        variant="body2"
        color="textSecondary"
        className={classes.empty}
      >
        {t("malware.list.noFiles")}
      </Typography>
    );
  }

  return (
    <div>
      {files.map(file => (
        <FileRow
          key={file.id}
          file={file}
          onClick={selected => onFileClick(selected, content)}
        />
      ))}
      {hasMoreFiles && (
        <Box padding="8px 16px 8px 72px">
          <ButtonWithLoading
            size="small"
            color="primary"
            loading={loading}
            onClick={() => onShowAll(content)}
          >
            {t("malware.list.showAllFiles", { count: content.filesCount })}
          </ButtonWithLoading>
        </Box>
      )}
    </div>
  );
}

const useStyles = makeStyles({
  empty: { padding: "14px 16px 14px 72px" },
});
